"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoCompleteItem = exports.AutoCompleteContainer = void 0;

var _borderRadius = require("@r1-frontend/ui-react/tokens/borderRadius");

var _colors = require("@r1-frontend/ui-react/tokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AutoCompleteContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__AutoCompleteContainer",
  componentId: "sc-1l3ckza-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-wrap: nowrap;\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    width: 100%;\n    height: auto;\n    max-height: 240%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background: ", ";\n    border: solid 1px ", ";\n    border-radius: ", ";\n    visibility: ", ";\n    z-index: 10;\n"])), _colors.COLORS.white, _colors.COLORS.grey, _borderRadius.BorderRadius.componentRadius, function (props) {
  return props.show ? 'visible' : 'hidden';
});

exports.AutoCompleteContainer = AutoCompleteContainer;

var AutoCompleteItem = _styledComponents["default"].div.withConfig({
  displayName: "styled__AutoCompleteItem",
  componentId: "sc-1l3ckza-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    flex-shrink: 0;\n    width: 100%;\n    height: 30px;\n    padding: 8px 13px;\n    cursor: pointer;\n    color: ", ";\n    background: ", ";\n\n    &:hover {\n        background: ", ";\n    }\n"])), function (props) {
  return props.focused ? _colors.COLORS.TextWhite : _colors.COLORS.TextPrimary;
}, function (props) {
  return props.focused ? _colors.COLORS.Control : _colors.COLORS.BgMain;
}, function (props) {
  return !props.focused && _colors.COLORS.lightGrey;
});

exports.AutoCompleteItem = AutoCompleteItem;